import React, { ReactNode } from 'react';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, Grid } from '@mui/material';
import Currency from 'components/formaters/Currency';
import ShareButton from 'components/common/ShareButton';
import { CarModel } from 'models/StockModel';
import { CompanyType } from 'models/CompanyModel';
import auth from 'recoil/atoms/auth';


type CarDataPlainProps = {
    car: CarModel,
    title: ReactNode,
}

const CarCardStatic = ({car, title}: CarDataPlainProps) => {
    const my = useRecoilValue(auth);
    const {t} = useTranslation('cars');

    return (
        <Card sx={{mb: 2}}>
            <CardHeader
                title={title}
                action={<ShareButton
                    title={`${car.make} ${car.model} ${car.chassisNumber}`}
                    url={`${process.env.REACT_APP_ORIGIN}/cars/${car.chassisNumber}`}
                />}
            />
            <CardContent>
                <Grid container>
                    {my.type !== CompanyType.PortAgent && (
                        <Grid item xs={12} sm={4}>
                            Export: in <strong>{car.exportMethod}</strong> as <strong>{car.exportType}</strong>
                        </Grid>
                    )}

                    <Grid item xs={12} sm={4}>
                        <strong>{car.vehicleType}</strong>, <strong>{car.seats}</strong> seats, <strong>{car.year}</strong> {car.color}
                    </Grid>
                    <Grid item xs={12} sm={4}>{t('price')}: <Currency value={car.unitPrice}/>, {car.priceTerms}</Grid>

                    <Grid item xs={4}>{t('engine')}: {car.engineSize}cc, {car.fuel}</Grid>
                    <Grid item xs={4}>{t('model')}: {car.engineModel}</Grid>
                    <Grid item xs={4}>{t('number')}: {car.engineNumber}</Grid>

                    <Grid item xs={6} sm={4}>{t('net_weight')}: {car.netWeight}</Grid>
                    <Grid item xs={6} sm={8}>{t('gross_weight')}: {car.grossWeight}</Grid>

                    <Grid item xs={6} sm={4}>
                        {t('size')}: {car.length}&times;{car.width}&times;{car.height}cm
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        {t('volume')}: {(car.length! * car.width! * car.height! / 1000000).toFixed(3)}M<sup>3</sup>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
};

export default CarCardStatic;
